/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectGroupIndicator_projectGroup = {
    readonly name: string | null;
    readonly companyProjectGroupId: number | null;
    readonly color: string | null;
    readonly " $refType": "ProjectGroupIndicator_projectGroup";
};
export type ProjectGroupIndicator_projectGroup$data = ProjectGroupIndicator_projectGroup;
export type ProjectGroupIndicator_projectGroup$key = {
    readonly " $data"?: ProjectGroupIndicator_projectGroup$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectGroupIndicator_projectGroup">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectGroupIndicator_projectGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectGroupId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "ProjectGroupType"
};
(node as any).hash = 'ce28c265c139a23c9a4727cea25732ab';
export default node;
